export default "__VITE_ASSET__BSm43PJz__";